import { getNamespaceName } from 'src/services/objects/namespaces';
import { capitalize } from 'src/utilities/capitalize';

export const CREATED = 'created';
export const UPDATED = 'updated';
export const EDITED = 'edited';
export const APPROVED = 'approved';
export const GENERATED = 'generated';
export const SUBMITTED = 'submitted';
export const PENDING = 'pending';
export const DECLINED = 'declined';
export const REMOVED = 'removed';
export const FAILED = 'failed';
export const ASSIGNED = 'assigned';
export const ASSIGNING = 'assigning';
export const STARTED = 'started';
export const COMPLETED = 'completed';
export const ACCEPTED = 'completed';
export const REQUESTED = 'requested';
export const RE_REQUESTED = 're-requested';
export const IMPORTED = 'imported';
export const ALREADY_ASSIGNED = 'already assigned';
export const A_NOTE = 'a note';
export const MARKED_COMPLETE = 'marked as complete';
export const LOWERCASE_DELETED = 'deleted';
export const LOWERCASE_COMPLETED = 'completed';
export const LOWERCASE_MARKED = 'marked';
export const DOWNLOADED = 'downloaded';
export const VIEWED = 'viewed';
export const REJECTED = 'rejected';
export const WITHDREW = 'withdrew'




export const THE_TASK = 'the Task';
export const THE_PAYSTUB = 'the paystub';
export const THE_NOTE = 'the note';
export const THE_APPLICATION = 'the loan application';

export const THE_APPLICATION_DELETE = 'the loan application delete request';
export const THE_DATA_MERCH = 'the Data Merch';
export const THE_SCHEDULE = 'the schedule';
export const THE_EXPERIAN = 'to Experian';
export const THE_TRANSUNION = 'to Transunion';
export const THE_UW_DECISION = 'to Underwriter Decision';
export const THE_UW_EXCEL = 'to Underwriter Excel';
export const THE_OCROLUS = 'to Ocrolus';
export const THE_DNB = 'Dun & Bradstreet';
export const THE_CONTRACT = 'the Contract';
export const THE_HARD_SOFTWARE = 'to Hart Software';
export const THE_RCN_SOFTWARE = 'to RCN Application PDF';
export const WEB_UI = 'WebUI';
export const STATUS_DONE = 'done';
export const APPLICATION = 'application';
export const REQUEST_INVITE = 'a request inviting';
export const STATUS_STARTED = 'Started';
export const LOAN_START_REASON = 'the loan application via the website';
export const LOAN_START_REASON_INVITE_LINK = 'the loan application via';
export const ANSWER_ON_BEHALF_CO = 'answer on behalf co-applicant'

export const LENDSMART_WITHOUT_BOT = `${capitalize(getNamespaceName())}`;

export const setLabelRedirectURL = (content: string) => {
  return `link_to_url(${content})`;
};
